module.exports = __webpack_public_path__ + "static/media/treinamento.19f14c9a.png";